export const STORAGE_USER = `invest_india_admin_user`;
